import { css, Styles, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-bottom: 6px;

    ${verticalScrollCss(theme)}
  `,
  itemPadding: css`
    padding: 0 6px;
  `,
  flexAlignment: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
